import React, { createContext, useContext } from 'react';
import { useState } from 'react';
import router from 'next/router';
import { useBiometrics } from '../biometrics/BiometricsContext';
import { useAuthContext } from '@/domains/auth/authContext';

type PinContextValue = {
  isForgotPin: boolean;
  handlePinReset: () => void;
  handlePinResetConfirm: () => void;
};

const PinContext = createContext<PinContextValue | undefined>(undefined);

export const PinProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { disable } = useBiometrics();
  const { logout } = useAuthContext();
  const [isForgotPin, setIsForgotPin] = useState(false);

  const handlePinReset = () => {
    setIsForgotPin(true);
  };

  const handlePinResetConfirm = async () => {
    await disable();
    await logout();
    setIsForgotPin(false);
    router.push('/hive/accounts/login');
  };

  return (
    <PinContext.Provider
      value={{ isForgotPin, handlePinReset, handlePinResetConfirm }}
    >
      {children}
    </PinContext.Provider>
  );
};

export const usePinContext = () => {
  const context = useContext(PinContext);
  if (!context) {
    throw new Error('usePinContext must be used within a PinProvider');
  }
  return context;
};
